import DialogDeleteWarningComponent from './DialogDeleteWarningComponent';
export default DialogDeleteWarningComponent;
